module.exports = __webpack_public_path__ + "static/media/moodle.63e19ec9.png";